const LSKey = "businessUnits.LastVisited.id"

export function getLastVisitedBusinessUnitId() {
  return localStorage.getItem(LSKey)
}

export function setLastVisitedBusinessUnitId(businessUnitId: string) {
  return localStorage.setItem(LSKey, businessUnitId)
}
